import * as userRoutines from '../../sagas/routines/userRoutines';
import { connect } from 'react-redux';
import { makeChannelDetailsFromForm, makeChannelWhitelist, makeInitialChannelForm } from './channelsSelectors';
import { makeDistinctUsersOrdered } from '../../redux/usersSelectors';
import { makeSearchableUsers } from '../../redux/usersSelectors';
import { updateChannel } from './channelRoutines';
import ChannelsModifyForm from '../../Components/Channels/Form/ChannelsModifyForm';

const mapState2Props = (state: any) => {
    return {
        activeEvent: state.ui.activeEvent || null,
        assembledChannel: makeChannelDetailsFromForm(state),
        distinctUsers: makeDistinctUsersOrdered(state), //Sorted distinct users
        initialData: makeInitialChannelForm(state),
        isEditing: state.channels.editing,
        madeWhitelist: makeChannelWhitelist(state), //Array of whitelisted channel users
        users: makeSearchableUsers(state), //Users to populate "searchableUsers"
        users_loading: state.users.users_loading,
    };
};

const mapDispatchToProps = {
    clearExtractedUsers: userRoutines.clearExtractedUsers,
    fetchUsersFromGroup: userRoutines.fetchUsersFromGroup,
    makeDistinctUsersFromCombined: userRoutines.makeDistinctUsersFromCombined,
    updateChannel,
};

export default connect(
    mapState2Props,
    mapDispatchToProps,
)(ChannelsModifyForm);
